import * as Yup from 'yup';

export const marketAreaFormSchema = Yup.object().shape({
    marketAreaName: Yup.string().required('Name is required'),
});
